import { applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createLogicMiddleware } from 'redux-logic'
import sharedEnhancers from './shared'
import { HttpClient } from './deps/http'
import createStorage from './deps/localStorage'
import { createKeycloak } from './deps/keycloak'
import User from '@engine/user'
import Comps from '@engine/comps'
import Property from '@engine/property'

const resolveBaseURL = () => {
  // Temporary Fix - Please remove this concept all together adn just keep local for the SErver
  const location = window.location.hostname
  const baseUrl = `https://${location}/kong`
  if (location === 'localhost') {
    return 'http://localhost:3000/kong'
  }
  // else if (window.location.hostname === 'compslabqc.berkadia.com') {
  //   return 'https://compslabqc.berkadia.com/api'
  // }

  return baseUrl
}

const getKeycloakConfigLocation = () => {
  if (window.location.hostname === 'compslab.berkadia.com' || window.location.hostname === 'compslab.prodberk8s.com') {
    return '/keycloak.prod.json'
  }

  return '/keycloak.qc.json'
}

const defaultStorage = createStorage()
export const defaultKeycloak = createKeycloak(getKeycloakConfigLocation())

const defaultHttp = new HttpClient({
  baseUrl: resolveBaseURL(),
  crossDomain: true,
  storage: defaultStorage,
  keycloak: defaultKeycloak
})

// inject middleware deps
// default options to non testing versions
const configureMiddleware = ({
  http = defaultHttp,
  storage = defaultStorage,
  keycloak = defaultKeycloak
} = {}) =>
  createLogicMiddleware(
    [
      ...User.processors,
      ...Comps.processors,
      ...Property.processors
    ],
    {
      http,
      storage,
      keycloak
    }
  )

// configures middleware store enhancers
export default deps =>
  composeWithDevTools(
    applyMiddleware(...sharedEnhancers, configureMiddleware(deps))
  )
